import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { useSelector } from "react-redux";

const points = [
  <>Get Recognised By Top MNCs And Startups</>,
  <span>
    Increase Salary Up To <span className="font-bold text-white"> 150% </span>
    <img
      alt=""
      width={17}
      src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/spike.png?updatedAt=1750494807792"
      className="ml-1 inline-block"
    />
  </span>,
  <>Stand Out From 20 Million+ Job Seekers</>,
];
const DefaultCertifiedCard = ({ handlerCertified }) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  return (
    <div
      className="flex w-full flex-col items-center justify-start rounded-[16px] p-4"
      style={{ background: "rgba(66, 133, 244, 0.15)" }}
    >
      <div className="flex w-full items-center gap-3">
        <img
          src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/Group%2023173.png?updatedAt=1750488521893"
          alt=""
          className="w-[25%]"
        />
        <div className="flex w-full flex-col justify-center">
          <div className="text-[16px] font-bold text-white md:text-[20px]">
            Get Certified To:
          </div>
          <div className="mt-3 flex flex-col gap-3">
            {points?.map((item, index) => (
              <div className="justiify-start semi-transparent-text flex items-center gap-[6px] text-[10px]   font-semibold md:text-[14px] ">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-[#2BBD13]"
                  size="xl"
                />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      <button
        className="mt-3 w-full cursor-pointer rounded-[12px] bg-[#7FC241] py-3  px-3 text-center text-[16px] font-medium text-[#121212] md:h-[52px] md:text-[18px]"
        onClick={(e) => {
          Mixpanel.track(
            Constants.Mixpanel
              .CERTIFICATE_VERIFICATION_DEFAULT_PAGE_GET_CERTIFIED_CLICKED,
          );
          handlerCertified({
            utm_medium: "get-certified",
            utm_source: "certificate-verification-default",
          });
        }}
      >
        Get Certified In Under 10 Minutes!
      </button>
    </div>
  );
};

export default DefaultCertifiedCard;
